import React, { useState, useEffect } from "react";
import { ICSIDUserStatus } from "../../../store/csid/types";
import * as services from "../../../store/service";
import * as csidUtil from "../../csid/csid";
import CreditReport from "../CreditReport/CreditReport";
import CreditScore from "../CreditScore/CreditScore";
import CreditLock from "../CreditLock/CreditLock";
import * as BusinessCreditReportAction from "../../../store/businessCreditReportService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useHistory } from "react-router-dom";

import BCreditReport from "../BusinessCreditReport/BCreditReport";
import BCreditScore from "../BusinessCreditScore/BCreditScore";

import CreditSimulator from "../CreditSimulator/CreditSimulator";
import CreditTab from "../CreditTab";
import PurchaseCreditReport from "../CreditReport/PurchaseCreditReport";
import FreezeMyCredit from "../FreezeMyCredit";
import EZSCreditAuthentication from "./EZSCreditAuthentication";
import IDFCreditAuthentication from "./IDFCreditAuthentication";
import TUAuthentication from "./TUAuthentication";
import { useDispatch } from "react-redux";
import * as CreditActions from "../../../store/credit/actions";
import { useBureauPermission } from "../../../util/credit";
import * as httpClient from "../../../util/httpClient";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";
import { RECEIVE_ONETIME_CREDIT, RECEIVE_CREDIT_DATA } from "../../../store/credit/types";
import BusinessCredit from "../BusinessCreditScore/BusinessCredit";
import { useAreServicesActive } from "../../../util/CommonServices";
import { toggleFullScreenLoader } from "../../../util/common";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import LogoContainer from "../../common/LogoContainer";
import * as CSIDActions from "../../../store/csid/actions";

const CreditPage = (props: any) => {
    const { t: tLang } = useTranslation();
    const history = useHistory();

    const [businessCreditReportStatePII, setBusinessCreditReportStatePII] = useState({} as BusinessCreditReportStatePII);
    const dispatch = useDispatch();
    const bureauPermission = useBureauPermission();
    const requestCreditHistory = (forcefullyRefresh: boolean) => dispatch(CreditActions.actionCreators.requestCreditHistory(forcefullyRefresh));
    const scoreOnlyIds = [
        idfServiceIds.creditScoreMonitoring,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
    ];
    const hasCreditScoreOnlyService = useAreServicesActive(scoreOnlyIds);
    const prioritizedServiceCode = useSelector((state: ApplicationState) => {
        if (state.creditHistoryData.isOneTimeOnlyScore && !hasCreditScoreOnlyService && !state.creditHistoryData.isOneTimeReportLatest) {
            return state.creditHistoryData.oneTimeScoreServiceCode;
        } else if (state.creditHistoryData.isOneTimeOnlyReport) {
            return state.creditHistoryData.oneTimeReportServiceCode;
        } else {
            return "";
        }
    });
    const requestCreditData = (forccefullyRefresh: boolean) =>
        dispatch(CreditActions.actionCreators.requestCreditData(forccefullyRefresh, bureauPermission, prioritizedServiceCode));
    const requestBusinessCreditReport = (ReportPK: any, forcefullyRefresh: boolean, creditProvider: string) =>
        dispatch(BusinessCreditReportAction.actionCreators.requestBusinessCreditReport(ReportPK, forcefullyRefresh, creditProvider));
    const updateCSIDStatus = (csidStatus: ICSIDUserStatus) => dispatch(CSIDActions.actionCreators.updateCSIDStatus(csidStatus));
    const refreshL3Status = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus(true));

    let { tabName } = props.match.params;
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showAuthenticatedPage, setShowAuthenticatedPage] = useState(false);
    const [initComplete, setInitComplete] = useState(false);
    const [isIDFuser, setIsIDFUser] = useState(false);
    const [csidUserStatus, setCSIDUserStatus] = useState({} as ICSIDUserStatus);
    const [selectedTab, setSelectedTab] = useState("1");
    const [purchasedReport, setPurchasedReport] = useState(false);
    const [purchasedReportData, setPurchasedReportData] = useState(null);
    const [selectedReportServiceCode, setSelectedReportServiceCode] = useState("");
    const [purchasedReportLoading, setPurchasedReportLoading] = useState(false);
    const [isBusinessProfileCreated, setIsBusinessProfileCreated] = useState(false);

    const l3Status = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    const creditHistory = useSelector((state: ApplicationState) => {
        return state.creditHistoryData.creditHistoryData;
    });

    const isPurchaseDisabled = useSelector((state: ApplicationState) => {
        return state.creditHistoryData.isPurchaseDisabled;
    });

    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const hasOneTimeScore = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeScore);
    const isOneTimeOnlyReport = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.isOneTimeOnlyReport);
    const viewedOneTimeScore = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.pageViewScore;
    });
    const purchasedOneTimeScore = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.purchasedReport;
    });
    const oneTimeScoreData = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.oneTimeCreditData;
    });

    let creditReportState = useSelector((state: ApplicationState) => {
        return state.creditState.creditData;
    });

    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const country = i18nService.get("Country");
    const showCreditFreeze = supportInternational ? country === "US" : true;

    const getUserCSIDStatus = () => {
        setIsLoading(true);
        services
            .getUserCSIDStatus()
            .then((data) => {
                if (data.StatusCode === 500) {
                    setIsLoading(false);
                    setHasError(true);
                } else {
                    setIsLoading(false);
                    const csidUserStatus: ICSIDUserStatus = data as ICSIDUserStatus;
                    updateCSIDStatus(csidUserStatus);
                    setIsIDFUser(csidUserStatus.isIDFUser);
                    setCSIDUserStatus(csidUserStatus);
                    if (csidUserStatus.isIDFUser || csidUserStatus.isTUUser) {
                        if (csidUserStatus["auth-status"] != null && csidUserStatus["auth-status"].toUpperCase() === "AUTHENTICATED") {
                            setShowAuthenticatedPage(true);
                        }
                    } else {
                        const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
                        switch (nextStep) {
                            case csidUtil.NEXT_STEP.GO_TO_DASHBOARD:
                                setShowAuthenticatedPage(true);
                                break;
                            default:
                                break;
                        }
                    }
                    if (initComplete === false) {
                        setInitComplete(true);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setHasError(true);
                if (initComplete === false) {
                    setInitComplete(true);
                }
            });
    };

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        if (isLoading) {
            toggleFullScreenLoader(true);
        } else {
            toggleFullScreenLoader(false);
        }
    }, [isLoading]);

    useEffect(() => {
        window.addEventListener("unload", () => {});
        // returned function will be called on component unmount
        return () => {
            if (hasOneTimeScore && purchasedOneTimeScore && !viewedOneTimeScore) {
                dispatch({ type: RECEIVE_ONETIME_CREDIT, oneTimeCreditData: oneTimeScoreData, purchasedReport: false, pageViewScore: true });
            }
            window.removeEventListener("unload", () => {});
        };
    }, []);

    const ensureDataFetched = () => {
        if (tabName === "score") {
            setSelectedTab("1");
        } else if (tabName === "report") {
            setSelectedTab("2");
        } else if (tabName === "simulator") {
            setSelectedTab("3");
        } else if (tabName === "lock") {
            setSelectedTab("4");
        } else if (tabName === "purchase" && !purchasedReport) {
            setSelectedTab("5");
        } else if (tabName === "mycredit") {
            setSelectedTab("6");
        }

        if (isBusinessUser) {
            setInitComplete(true);
            setIsIDFUser(false);
            setShowAuthenticatedPage(true);
            if (businessProfileStatus != null && businessProfileStatus.length > 0) {
                setIsBusinessProfileCreated(businessProfileStatus[0].status === "COMPLETED");
                requestBusinessCreditReport(null, false, businessProfileStatus[0].provider);
                // if state hasn't already been set, call API and set state
                if (businessCreditReportStatePII.businessCompanyReport == null) {
                    setIsLoading(true);
                    services
                        .getBusinessCreditReport(null, businessProfileStatus[0].provider)
                        .then((data) => {
                            setIsLoading(false);
                            setBusinessCreditReportStatePII({ businessCompanyReport: data[0].businessCompanyReport });
                        })
                        .catch(function (error) {
                            setIsLoading(false);
                        });
                }
            }
        } else {
            getUserCSIDStatus();
        }
    };

    const isCreditBureauInformationActive = useAreServicesActive([
        ezsServiceIds.businessCreditServiceBusinessCredit,
        ezsServiceIds.businessCreditServiceBusinessCreditPro,
        ezsServiceIds.businessCreditServiceBusinessCreditSelect,
    ]);

    const changeTab = (tabIndex?: string, purchaseReportTabChange?: boolean, selectedServiceCode?: string) => {
        if (purchaseReportTabChange) {
            let serviceCode = selectedServiceCode ? selectedServiceCode : "";
            setSelectedReportServiceCode(serviceCode);
            if (l3Status?.["auth-status"]?.toUpperCase() === "AUTHENTICATED") {
                fetchReportByServiceCode(serviceCode);
            } else {
                refreshL3Status();
            }
        }
        setSelectedTab("2");
    };

    const fetchReportByServiceCode = (serviceCode: string) => {
        if (serviceCode) {
            setSelectedReportServiceCode("");
            setPurchasedReport(true);
            setPurchasedReportLoading(true);

            // fetch the report, but don't add it to the store, this way we only see it the one time
            const requestBody = {
                "service-code": serviceCode,
                action: "PURCHASE_ONETIME",
            };
            httpClient
                .sendRequest("POST", `api/credit-monitoring/getCreditScoreData`, requestBody)
                .then((data) => {
                    requestCreditHistory(true);
                    setPurchasedReportData(data);
                    // add this data to the store, so that we can use it on the score page
                    dispatch({ type: RECEIVE_ONETIME_CREDIT, oneTimeCreditData: data, purchasedReport: true });
                    // save state if its one time report only
                    if (isOneTimeOnlyReport) {
                        let creditData = creditReportState;
                        creditData.unshift(data);
                        dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditData });
                    }
                    setPurchasedReportLoading(false);
                    history.push("/credit/report");
                })
                .catch(function (error) {
                    console.log(error);
                    setPurchasedReportLoading(false);
                });
        }
    };

    //TODO Bug 17825
    useEffect(ensureDataFetched, [tabName, purchasedReport, businessProfileStatus && businessProfileStatus.length > 0 && businessProfileStatus[0]?.status]);

    useEffect(() => {
        requestCreditHistory(false);
    }, []);

    useEffect(() => {
        if (selectedReportServiceCode && l3Status?.["auth-status"]?.toUpperCase() === "AUTHENTICATED") {
            fetchReportByServiceCode(selectedReportServiceCode);
        }
    }, [l3Status]);

    useEffect(() => {
        let tabClickFlag = false;
        document.addEventListener("keydown", function (event) {
            if (event.key === "Tab" && !tabClickFlag) {
                let skipBtn = document.getElementById("skip-main-btn");
                if (skipBtn) {
                    skipBtn.focus();
                }
                event.preventDefault();
                tabClickFlag = true;
            }
        });
    }, [tabName]);

    const creditAuthSuccessCallBack = (callbackObj?: any) => {
        getUserCSIDStatus();
        requestCreditData(true);
    };

    return (
        <React.Fragment>
            <TUAuthentication />

            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page">{tLang("credit.title")}</h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            {hasError ? (
                <div className="row">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                    <em className="las la-exclamation-triangle"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">{tLang("credit.authErrorHeader")}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <p>{tLang("credit.authErrorMessage")}</p>
                        </div>
                    </div>
                    <div></div>
                </div>
            ) : (
                <div className={`${purchasedReportLoading && "loading"}`}>
                    <div className="row min-height" id="content">
                        <div className="col-xs-12" style={{ padding: "0.5rem 0px" }}>
                            {selectedTab === "1" && <CreditTab selectedTab="1" />}
                            {selectedTab === "2" && <CreditTab selectedTab="2" purchasedReport={purchasedReport} />}
                            {selectedTab === "3" && <CreditTab selectedTab="3" />}
                            {selectedTab === "4" && <CreditTab selectedTab="4" />}
                            {selectedTab === "5" && <CreditTab selectedTab="5" purchasedReport={purchasedReport} />}
                            {selectedTab === "6" && <CreditTab selectedTab="6" />}
                            {tabName === "purchase" && hasPurchaseCreditReport && !purchasedReport && (
                                <PurchaseCreditReport changeTabCallback={changeTab} purchaseDisabled={isPurchaseDisabled} />
                            )}
                            {tabName === "mycredit" && showCreditFreeze && <FreezeMyCredit />}
                            {initComplete && tabName !== "mycredit" && (
                                <React.Fragment>
                                    {isBusinessProfileCreated ? (
                                        <React.Fragment>
                                            {isBusinessUser && isCreditBureauInformationActive && tabName === "score" && (
                                                <BCreditScore reportObject={businessCreditReportStatePII} />
                                            )}
                                            {isBusinessUser && isCreditBureauInformationActive && tabName === "report" && (
                                                <BCreditReport reportObject={businessCreditReportStatePII} />
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <React.Fragment>
                                                {isBusinessUser && isCreditBureauInformationActive && tabName === "score" && <BusinessCredit selectedTab={"1"} />}
                                                {isBusinessUser && isCreditBureauInformationActive && tabName === "report" && <BusinessCredit selectedTab={"2"} />}
                                            </React.Fragment>
                                        </React.Fragment>
                                    )}
                                    {!isBusinessUser && showAuthenticatedPage && tabName === "score" && <CreditScore />}
                                    {!isBusinessUser && showAuthenticatedPage && tabName === "report" && (
                                        <CreditReport
                                            purchasedReport={purchasedReport}
                                            purchasedReportData={purchasedReportData}
                                            recentCreditReport={creditHistory ? creditHistory.length > 0 && creditHistory[0] : []}
                                        />
                                    )}
                                    {!isBusinessUser && showAuthenticatedPage && tabName === "lock" && <CreditLock />}
                                    {showAuthenticatedPage && tabName === "simulator" && <CreditSimulator />}
                                    {!showAuthenticatedPage &&
                                        tabName !== "purchase" &&
                                        csidUserStatus &&
                                        (csidUserStatus.l3AuthProvider.isTU || csidUserStatus.l3AuthProvider.isIDF) && (
                                            <IDFCreditAuthentication
                                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                                creditAuthCallback={creditAuthSuccessCallBack}
                                                displayFlowAsDialog={true}
                                            />
                                        )}
                                    {!showAuthenticatedPage && tabName !== "purchase" && csidUserStatus && csidUserStatus.l3AuthProvider.isExperian && (
                                        <EZSCreditAuthentication
                                            initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                            creditAuthCallback={creditAuthSuccessCallBack}
                                            displayFlowAsDialog={true}
                                            l3Case={"credit-service"}
                                        />
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};
export default CreditPage;
